export enum CARGO_STAGES {
  STAGE1 = "STAGE1",
  STAGE2 = "STAGE2",
  STAGE3 = "STAGE3",
}
